import {
    INPUT_NAVIGATION_AND_ERASE_ARROWS,
    INPUT_NUMERIC_KEYCODES,
} from "../../constants/keycodes";

export const getReactHookFormHelpers = (
    { watch, setValue },
    formControlKey,
    { applyDelay = false, getValueFromEvent, applyOnBlur = true } = {}
) => {
    if (!watch || !setValue) {
        return {};
    }
    return {
        value: watch(formControlKey),
        onChange: ev => {
            const target = ev.target || ev.currentTarget;
            if (applyDelay) {
                setTimeout(() => {
                    const delayedValue = getValueFromEvent
                        ? getValueFromEvent(ev)
                        : (ev.target || ev.currentTarget).value;
                    setValue(formControlKey, delayedValue, true);
                }, 10);
            } else {
                const value = getValueFromEvent ? getValueFromEvent(ev) : target.value;
                setValue(formControlKey, value, true);
            }
        },
        onBlur: () => {
            if (applyOnBlur) {
                setValue(formControlKey, watch(formControlKey), true);
            }
        },
    };
};

export const isInvalid = (
    { errors, formState: { touched = [], dirty } },
    formControlKey
) => {
    console.log(formControlKey)
    console.log(errors)
    return !!errors[formControlKey] && touched.includes(formControlKey);
};

export const isInvalidWithoutTouched = ({ errors }, formControlKey) => {
    return !!errors[formControlKey];
};

export const _replaceAccentMark = phrase => {
    const from = "ÃÀÁÄÂÈÉËÊÌÍÏÎÒÓÖÔÙÚÜÛãàáäâèéëêìíïîòóöôùúüûÑñÇç";
    const to = "AAAAAEEEEIIIIOOOOUUUUaaaaaeeeeiiiioooouuuunncc";
    const mapping = {};
    for (let i = 0, j = from.length; i < j; i++) mapping[from.charAt(i)] = to.charAt(i);
    const convertAccentMark = str => {
        const ret = [];
        for (let i = 0, j = str.length; i < j; i++) {
            const c = str.charAt(i);
            // eslint-disable-next-line no-prototype-builtins
            if (mapping.hasOwnProperty(str.charAt(i))) ret.push(mapping[c]);
            else ret.push(c);
        }
        return ret.join("");
    };
    return convertAccentMark(phrase);
};

export const inputNotSpecialCharacter = (
    { watch, setValue },
    formControlKey,
    replaceAccentMark
) => {
    return {
        onChange: ev => {
            const strValue = String(watch(formControlKey));
            let convertedStr = "";
            if (replaceAccentMark) {
                convertedStr = _replaceAccentMark(strValue);
            }
            convertedStr = convertedStr.replace(/[^a-z0-9\s]/gi, "");
            setValue(formControlKey, convertedStr, true);
            ev.target.dataset.lastValidValue = convertedStr;
        },
    };
};

export const inputNumberStaticHelpers = (
    { watch, setValue },
    formControlKey,
    { numberStatic, lengthValidator }
) => {
    return {
        onChange: ev => {
            const strValue = String(watch(formControlKey));
            const _lengthValidator =
                lengthValidator instanceof RegExp
                    ? valStr => lengthValidator.test(valStr)
                    : lengthValidator;
            const isValid = _lengthValidator
                ? _lengthValidator(String(watch(formControlKey)))
                : true;
            if (!isValid) {
                setValue(formControlKey, ev.target.dataset.lastValidValue, true);
            } else if (
                numberStatic !== strValue &&
                strValue.length < numberStatic.length
            ) {
                setValue(formControlKey, numberStatic, true);
            } else {
                setValue(formControlKey, strValue, true);
                ev.target.dataset.lastValidValue = strValue;
            }
        },
    };
};

export const inputMaxLengthHelpers = (
    { watch, setValue },
    formControlKey,
    { lengthValidator, availableKeys = INPUT_NUMERIC_KEYCODES } = {}
) => {
    return {
        onKeyDown: ev => {
            if (availableKeys && availableKeys.indexOf(ev.keyCode) < 0) {
                ev.preventDefault();
            }
        },
        onChange: ev => {
            const strValue = String(watch(formControlKey));
            const _lengthValidator =
                lengthValidator instanceof RegExp
                    ? valStr => lengthValidator.test(valStr)
                    : lengthValidator;
            const isValid = _lengthValidator
                ? _lengthValidator(String(watch(formControlKey)))
                : true;
            if (!isValid) {
                if (!INPUT_NAVIGATION_AND_ERASE_ARROWS.includes(ev.keyCode)) {
                    const lastValue = ev.target.dataset.lastValidValue;
                    setValue(formControlKey, lastValue, true);
                }
            } else {
                ev.target.dataset.lastValidValue = strValue;
            }
        },
        onDrop: () => false,
        onPaste: () => false,
    };
};
